const LOAD_DETAIL_JOB_POSITIONS           = 'LOAD_DETAIL_JOB_POSITIONS'
const LOAD_DETAIL_JOB_POSITIONS_SUCCESS   = 'LOAD_DETAIL_JOB_POSITIONS_SUCCESS'
const LOAD_DETAIL_JOB_POSITIONS_FAILED    = 'LOAD_DETAIL_JOB_POSITIONS_FAILED'
const UNMOUNT_DETAIL_JOB_POSITIONS        = 'UNMOUNT_DETAIL_JOB_POSITIONS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobPositionsDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_JOB_POSITIONS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_JOB_POSITIONS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_JOB_POSITIONS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_JOB_POSITIONS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobPositionsDetailReducer;